const DocumentNumberMaskUtil = (dn) => {
    let rtn = dn;
    if(dn.length === 11) {
        rtn = `${dn.substring(0,3)}.${dn.substring(3,6)}.${dn.substring(6,9)}-${dn.substring(9,11)}`;
    } else if(dn.length === 13) {
        rtn = `${dn.substring(0,2)}.${dn.substring(2,5)}.${dn.substring(5,8)}/${dn.substring(8,11)}-${dn.substring(12,13)}`;
    }
    return rtn;
};

export default DocumentNumberMaskUtil;